// extracted by mini-css-extract-plugin
export var header = "_g7-0";